
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class BaseCurrency extends Vue {
  @Prop() symbol!: string;

  toggleBase() {
    this.$emit("base-change", this.$props.symbol === "USD" ? "EUR" : "USD");
  }
}
